function getIcon(icon, cssClasses) {
    let iconCssClasses = ['icon', `icon--${icon}`];

    if (cssClasses) {
        iconCssClasses = [...iconCssClasses, ...cssClasses];
    }

    return `<svg class="${iconCssClasses.join(' ')}">
        <use xlink:href="#${icon}"></use>
    </svg>`;
}

function getLabel(label, showLabel) {
    return showLabel ? label : `<span class="visually-hidden">${label}</span>`;
}

function tooltip(data) {
    const cssClasses = data.cssClasses ?? ['btn', 'btn-link'];
    const iconCssClasses = data.iconCssClasses ?? null;
    const showLabel = data.showLabel ?? true;
    const icon = data.icon ?? 'info';
    const showIcon = data.showIcon ?? true;
    const iconPosition = data.iconPosition ?? 'start';
    const customCssClasses = data.customCssClasses ?? null;
    const popperPlacement = data.popperPlacement ?? '';

    if (!showLabel) {
        cssClasses.push('btn--no-label');
    }

    if (iconPosition === 'end') {
        cssClasses.push('flex-row-reverse');
    }

    const inner = `
        ${(icon && showIcon) ? getIcon(icon, iconCssClasses) : ''}
        ${data.label ? getLabel(data.label, showLabel) : ''}
    `;

    const trackingAttrs = data.track
        ? `data-track="true"${
            data.trackData ? ` data-track-data='${JSON.stringify(data.trackData)}'` : ''
        }`
        : '';

    const commonAttrs = `
        class="${cssClasses.join(' ')}"
        data-pulse-component="tooltip"
        data-bs-toggle="tooltip"
        data-taxonomy-url="${data.taxonomyUrl}"
        title="${data.text}"
        data-popper-placement="${popperPlacement}"
        ${trackingAttrs}
        ${customCssClasses ? `data-bs-custom-class="${customCssClasses}"` : ''}
        ${data.namespace ? `data-namespace="${data.namespace}"` : ''}
    `.trim();

    // If there is a URL, render an <a> styled as a button
    if (data.url) {
        return `
            <a href="${data.url}" ${commonAttrs}>
                ${inner}
            </a>
        `;
    }

    // Otherwise, render a real button
    return `
        <button type="button" ${commonAttrs}>
            ${inner}
        </button>
    `;
}

function compile(data) {
    return tooltip(data);
}

export default compile;
